<template>
    <div class="header">
        <el-row class="navs">
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content bg-purple"></div></el-col>
            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                <div class="grid-content bg-purple-light right">
                    <ul >
                        <li @click="goLogin()" v-if="showname" >登录</li>
                        <li @click="logonFunc()" v-if="showname"> 注册 |</li>
                        <li v-else>
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    {{userCompany}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="goMsg()">个人中心</el-dropdown-item>
                                    <el-dropdown-item @click.native="goOut()">退出登录</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </li>
                        <!-- <li>|</li> -->
                        
                        <!-- <li>|</li> -->
                        <!-- <li>语种切换: <span @click="goRu()">俄文 |</span></li> -->
                        <li>语种切换: <a href="http://www.cninvestru.com/union-ru/index.html">русский язык  </a> | </li>
                    </ul>
                </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content bg-purple"></div></el-col>
        </el-row>
        <el-row class="top">
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content bg-purple"></div></el-col>
            <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                <div class="title">
                    <div>中国在俄投资实体企业联合会</div>
                    <span>СОЮЗ РОССИЙСКИХ ПРЕДПРИЯТИЙ С УЧАСТИЕМ КИТАЙСКИХ ИНВЕСТИЦИЙ</span>
                </div>
            </el-col>
            <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content bg-purple"></div></el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name:"header",
    data () {
        return {
            showname:true,
            userCompany:sessionStorage.getItem('name'),
        }
    },
    mounted() {

        this.login();
    },
    updated() {
        // this.login()
        // if(this.userCompany == "" ){
        //     this.showname = true;
        // }else if( this.userCompany == null){
        //     this.showname = true;
        // }else{
        //     this.showname = false;
        // }
    },
    methods: {
        login(){
            
            if(this.userCompany == "" ){
                this.showname = true;
            }else if( this.userCompany == null){
                this.showname = true;
            }else{
                this.showname = false;
            }
        },
        
        goLogin(){
            this.$router.push({path:"/login"})
        },
        goMsg(){

            this.$router.push({path:"/msg"})
        },
        //注册
        logonFunc(){
            this.$router.push({ path: '/logon'})
        },
        //退出登录
        goOut(){
            sessionStorage.clear();
            this.$router.go(0)
        }

    },
}
</script>
<style scoped >
    a{
        text-decoration: none;
        color:#ccc;
    }
    .navs{
        color:#656565;
    }
    .bg-purple-dark {
        background: #656565;
    }
    .bg-purple {
        background: #656565;
    }
    .bg-purple-light {
        background: #656565;
    }
    .grid-content {
        min-height: 40px;
    }
    
    .navs .right li{
        float:right;
        line-height:40px;
        font-size:16px;
        list-style: none;
        margin:0 4px;
        color:#ccc;
    }
    /* 名称 */
    .header .top{
        width:100%;
        height:140px;
        margin-top:10px;
        margin-bottom:10px;
        background-color: #1f3356;
        color:#fff;
    }
    .header .top .grid-content{
        min-height:100px;
        background-color: #1f3356;
    }
    .header .top .title{
        box-sizing: border-box;
        padding:30px 0 20px 0;
        text-align: center;
        /* line-height:60px; */
    }
    .header .top .title div{
        font-size:38px;
    }
    .header .top .title span{
        font-size:28px;
    }

    .el-dropdown-link{
        color:#fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/headerPage.vue